// Umami coarsens day buckets to months past ~6 months, so the API caps daily at 180.
const MAX_DAILY_DAYS = 180

export function visitorChartMonths(days: number): number | null {
	return days > MAX_DAILY_DAYS ? Math.round((days * 12) / 365) : null
}
